import React, { useState, useEffect, useRef } from 'react';
//import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";

import { content_language} from '../../../Utils';

import Navbar from '../Navbar/Navbar_00';
import Footer from '../Footer/Footer_00';
import Loader from '../../../loader';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

import { language } from '../WEBContent/Language';

//import AssecImage from "../ASSEC_Image/Image"

import './Content.css';

export default function InstagramFeed(props) {

    const [dados_config, set_dados_config] = useState({});
    const [navbar, set_navbar] = useState({});

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));

    const [/*lang_id*/, set_lang_id] = useState('1');

    const content_interface = {
        id: '',
        info: {},
        content: {}
    }
    const [, set_dados_content] = useState(null)
    const content = useRef(content_interface)

    const [pluginLink, setPluginLink] = useState('');

    useEffect(() => {

        try {

            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })

            let getInfoProps = async () => { 
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_navbar(props.dados_navbar)
                }
            
                if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                    set_dados_config(props.dados_config)
                    if(props.dados_config.content[0].instagram_feed !== undefined && props.dados_config.content[0].instagram_feed !== null) {
                        setPluginLink(props.dados_config.content[0].instagram_feed)
                    }
                }

                set_dados_content(content.current = {id: '', info: {type: 'instagram', layout: 'all'}, content: []})
            }
			
            (async () => {
                await getInfoProps()
                setLoading(false)
            })()

            return

        } catch {
            console.log('nada')

			return
		}
        
    }, [props]);

    return (isloading ?
		<Loader />
	:
        <>
            <Navbar dados_config={dados_config} dados_navbar={navbar} />
            <Breadcrumb dados_config={dados_config} dados_navbar={navbar} dados_content={content.current} />
            <main className="instagram-feed my-5">
                <div className="container">
                    <div className="title-properties">
                        <h1 className={"titulo-pp"}>
                            {language[lang].publications} 
                        </h1>
                    </div>
                    <iframe title="Instagram Feed" src={pluginLink} /*src="https://embedsocial.com/api/pro_hashtag/c1e45a691fd0824515427747b1e7708388437534"*/ width="100%" /*height="2100px"*/></iframe>
                </div>
            </main>
            <Footer dados_config={dados_config} dados_navbar={navbar} />
        </>
    )
}